import script from "./TemplateDownloadBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateDownloadBtn.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateDownloadBtn.vue?vue&type=style&index=0&id=2fad94db&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fad94db"]])

export default __exports__